import { Injectable } from '@angular/core';
import { TooltipDirective } from './tooltip.directive';

@Injectable({ providedIn: 'root' })
export class TooltipService {
  [x: string]: any;
  private activeTooltip: TooltipDirective | null = null;

  registerTooltip(tooltip: TooltipDirective): void {
    if (this.activeTooltip) {
      this.deregisterTooltip(this.activeTooltip);
    }
    this.activeTooltip = tooltip;
    this.activeTooltip.open();
  }

  deregisterTooltip(tooltip: TooltipDirective): void {
    if (this.activeTooltip === tooltip) {
      this.closeActiveTooltip();
    }
  }

  isActive(tooltip: TooltipDirective): boolean {
    return this.activeTooltip === tooltip;
  }

  closeActiveTooltip(): void {
    this.activeTooltip?.close();
    this.activeTooltip = null;
  }
}
